import { gql } from '@apollo/client';

export const ANSWER_WIDOW = gql`
  mutation answerWidow($input: AnswerWidowInput!) {
    answerWidow(input: $input) {
      questions {
        id
        status
      }
      profile {
        id
        maritalStatus
        widowClassification {
          id
          classification
        }
      }
    }
  }
`;
